<template>
  <div>
    <div class="cnt" :class="{'zy-show':scrollPosition>50}">
      <div style="position: relative">
        <div class="cnt-content">
          <div class="item " @click="handleTop">
            <i class="el-icon-upload2"></i>
            <div class="item-text">置顶</div>
          </div>
          <div class="cnt-line"></div>
          <div class="wechat item" @mouseover="hoverWechat(true)" @mouseleave="hoverWechat(false)">
            <img alt="" src="@/assets/images/index/weichat-2.png" class="wei-chat-img"/>
            <div class="item-text">微信客服</div>
          </div>
        </div>
      </div>
    </div>
    <div class="qr-bar" v-if="wechatHover">
      <img class="qrcode" src="@/assets/images/index/qr-code-2.png"/>
    </div>
  </div>

</template>

<script>
export default {
  data() {
    return {
      scrollPosition: 0,
      wechatHover: false,
      topHover: false
    }
  },
  mounted() {
    let that = this
    window.addEventListener('scroll', function () {
      that.scrollPosition = window.scrollY;
    });
  },
  methods: {
    hoverWechat(isHovered) {
      this.wechatHover = isHovered
    },
    hoverTop(isHovered) {
      this.topHover = isHovered
    },
    handleTop() {
      let distance = document.documentElement.scrollTop || document.body.scrollTop; //获得当前高度
      let step = distance / 30; //每步的距离
      (function jump() {
        if (distance > 0) {
          distance -= step;
          window.scrollTo(0, distance);
          setTimeout(jump, 10);
        }
      })();
    }
  }
}
</script>

<style scoped lang="scss">
.cnt {
  position: fixed;
  right: 20px;
  top: 50vh;
  z-index: 50;
  display: flex;
  visibility: hidden;
  filter: alpha(opacity=0);
  opacity: 0;
  transition: 0.2s ease-out;

  .cnt-content {
    width: 60px;
    background: #1F4FFC;
    border-radius: 6px;
  }

  .el-icon-upload2 {
    font-size: 22px;
  }

  .cnt-line {
    width: 60px;
    height: 1px;
    background: #E2E9FF;
  }

  .item {
    display: flex;
    flex-direction: column;
    align-items: center;
    cursor: pointer;
    color: #fff;
  }

  .item:nth-child(1) {
    padding-top: 16px;
    padding-bottom: 12px;
  }

  .item:last-child {
    padding-top: 12px;
    padding-bottom: 12px;
  }

  .item-text {
    font-size: 10px;
    font-weight: 400;
    color: #FFFFFF;
    padding-top: 2px;
  }

  .wei-chat-img {
    width: 30px;
    height: 24px;
  }

  .scroll-top {
    font-size: 20px;
    font-weight: 500;
    margin-top: 10px;
    background-color: #ff2020;
    text-align: center;
  }
}

.zy-show {
  visibility: visible;
  filter: alpha(opacity=100);
  opacity: 1;
  -webkit-box-shadow: 0px -6px 6px 0px rgba(0, 0, 0, 0.06);
  box-shadow: 0px -6px 6px 0px rgba(0, 0, 0, 0.06);
}

.qr-bar {
  position: fixed;
  right: 90px;
  top: 57vh;
  z-index: 60;
  display: block;
  box-shadow: 0px 0 52px 0px rgba(225, 225, 246, 0.45);
}

.qrcode {
  width: 120px;
  height: 120px;
}
</style>
